import React, { useState } from 'react'
import ModalVideo from 'react-modal-video'
import style from './modal.mod.scss'
import Play from '@svgs/playButton.svg'
import { isBrowser } from '@context/themeContext'
import ReactDOM from 'react-dom'

const windowAvailable = isBrowser()

const appRoot = windowAvailable && window.document.querySelector('#___gatsby')

const Modal = ({ video, modifiers = [] }) => {
  const [isOpen, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div className={[style.modal, ...modifiers].join(' ')}>
      <div className={style.modal__wrap}>
        {video &&
          windowAvailable &&
          ReactDOM.createPortal(
            <ModalVideo
              isOpen={isOpen}
              channel={video.provider}
              videoId={video.providerUid}
              onClose={handleClose}
              autoplay
            />,
            appRoot
          )}
        <button
          aria-label={`Open modal and play video: ${video.title}`}
          className={[style.modal__button, 'swiper-no-swiping'].join(' ')}
          onClick={handleOpen}
        >
          <Play />
        </button>
      </div>
    </div>
  )
}

export default Modal
